var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.825 7.5H12.5V3.33333C12.5 2.875 12.125 2.5 11.6667 2.5H8.33332C7.87499 2.5 7.49999 2.875 7.49999 3.33333V7.5H6.17499C5.43332 7.5 5.05832 8.4 5.58332 8.925L9.40832 12.75C9.73332 13.075 10.2583 13.075 10.5833 12.75L14.4083 8.925C14.9333 8.4 14.5667 7.5 13.825 7.5ZM4.16666 15.8333C4.16666 16.2917 4.54166 16.6667 4.99999 16.6667H15C15.4583 16.6667 15.8333 16.2917 15.8333 15.8333C15.8333 15.375 15.4583 15 15 15H4.99999C4.54166 15 4.16666 15.375 4.16666 15.8333Z",
    fill: "#5C5C5C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadFile);
export default __webpack_public_path__ + "static/media/downloadFile.a6124e3546cd08fbbc3a273988b86f6f.svg";
export { ForwardRef as ReactComponent };